import React from 'react';
import { Button, Card, Col, Row } from 'react-bootstrap';
import ProgramDeadlinesDialog from '@/components/common/ProgramDeadlinesDialog';
import {
    formatDate,
    programApplicationDates,
    releaseSentence,
} from '@/components/common/programTermDates';

/**
 * A program's application, review, decision-release and term dates for the
 * selected term, with the button that opens the dialog to change them.
 * The dialog's open state belongs to the dashboard, so the header's
 * missing-dates link can open it after switching to this section.
 */
function ProgramDeadlinesSection({
    programType,
    programLabel,
    programName,
    selectedTerm,
    onTermUpdated,
    show,
    onShow,
    onHide,
}) {
    const pw = selectedTerm?.programWindows?.[programType];
    const applicationDates = programApplicationDates(selectedTerm, programType);

    return (
        <Card className="border-0 shadow-sm">
            <Card.Body>
                <h2 className="h5">Application deadlines</h2>
                <Row className="small text-muted g-3 mt-0">
                    <Col xs={6} md={3}>
                        <strong className="d-block">
                            {programLabel} Applications
                        </strong>
                        {formatDate(applicationDates.open)} &ndash;{' '}
                        {formatDate(applicationDates.close)}
                    </Col>
                    <Col xs={6} md={3}>
                        <strong className="d-block">
                            {programLabel} Review
                        </strong>
                        {formatDate(pw?.reviewStart)} &ndash;{' '}
                        {formatDate(pw?.reviewEnd)}
                    </Col>
                    <Col xs={6} md={3}>
                        <strong className="d-block">Decisions</strong>
                        {formatDate(pw?.decisionsReleased)}
                        <span className="d-block">
                            {releaseSentence(pw?.decisionsReleased)}
                        </span>
                    </Col>
                    <Col xs={6} md={3}>
                        <strong className="d-block">Term</strong>
                        {formatDate(selectedTerm?.startDate)} &ndash;{' '}
                        {formatDate(selectedTerm?.endDate)}
                    </Col>
                </Row>
                <Button
                    variant="outline-primary"
                    className="mt-3"
                    onClick={onShow}
                >
                    Manage {programLabel} Deadlines
                </Button>
            </Card.Body>
            <ProgramDeadlinesDialog
                show={show}
                onHide={onHide}
                programType={programType}
                programLabel={programLabel}
                programName={programName}
                selectedTerm={selectedTerm}
                onTermUpdated={onTermUpdated}
            />
        </Card>
    );
}

export default ProgramDeadlinesSection;
